module.exports = __webpack_public_path__ + "static/Ecoservice-967191acc05a42d751a0c5973be417b7.png";